import { render, staticRenderFns } from "./UnidadeDetalhes.vue?vue&type=template&id=d1ec6e6c"
import script from "./UnidadeDetalhes.vue?vue&type=script&lang=js"
export * from "./UnidadeDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports